import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const DifferentiatorsSection = () => {
  const differentiators = [
    {
      id: 1,
      icon: 'Tag',
      title: 'Materials at Cost',
      features: [
        'No contractor markup',
        'Real supplier pricing',
        'Homeowners see exactly what materials cost'
      ]
    },
    {
      id: 2,
      icon: 'UserX',
      title: 'No Sales Commissions',
      features: [
        'No high-pressure sales tactics',
        'No inflated pricing to cover commissions',
        'Technology-driven roof prices instead'
      ]
    },
    {
      id: 3,
      icon: 'Shield',
      title: 'OpenbooQ-Managed Installers',
      features: [
        'Licensed and insured crews',
        'Standardized install requirements',
        'Quality control handled by OpenbooQ'
      ]
    },
    {
      id: 4,
      icon: 'Zap',
      title: 'Technology-Driven Pricing',
      features: [
        'Roof prices',
        'Standardized pricing logic',
        'No "good, better, best" manipulation'
      ]
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
          className="space-y-16">
          
          {/* Header */}
          <motion.div variants={itemVariants} className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-jakarta font-bold text-[#000150] leading-[1.1]">
              How OpenbooQ Is{' '}
              <span className="text-[#07B0E9]">Different</span>
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              We're not just another roofing company. We're a technology platform that eliminates the overhead that has nothing to do with roof quality.
            </p>
          </motion.div>

          {/* Differentiators Grid */}
          <motion.div 
            variants={containerVariants}
            className="grid md:grid-cols-2 gap-8 lg:gap-12">
            {differentiators?.map((item) => (
              <motion.div
                key={item?.id}
                variants={itemVariants}
                whileHover={{ scale: 1.02 }}
                className="bg-gradient-to-br from-slate-50 to-white p-10 rounded-2xl border border-gray-200 hover:border-cyan-300 hover:shadow-xl transition-all duration-300">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-cyan-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <Icon name={item?.icon} size={32} className="text-cyan-600" />
                  </div>
                  <div className="space-y-4">
                    <h3 className="text-2xl font-jakarta font-bold text-[#000150]">
                      {item?.title}
                    </h3>
                    <ul className="space-y-3">
                      {item?.features?.map((feature, index) => (
                        <li key={index} className="flex items-start gap-3">
                          <Icon name="Check" size={20} className="text-green-600 flex-shrink-0 mt-0.5" />
                          <span className="text-gray-600 leading-relaxed">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default DifferentiatorsSection;